// src/features/monetize/useMonetizeStatus.ts

import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { FEATURE_FLAGS } from '@/lib/constants/featureFlags';
import { MONETIZE_QUERY_KEYS } from '@/lib/constants/monetize';
import { MonetizeApi } from './MonetizeApi';

/**
 * The api's Monetize verdict for the selected account, with its profile and
 * connected account when enabled. Runs only when the flag is on and the user
 * has media access, so a dark build or an upload-only user never calls it.
 */
export function useMonetizeStatus() {
  const { selectedCId, canViewMedia } = useAuth();
  const enabled = FEATURE_FLAGS.monetizeEnabled && canViewMedia && selectedCId != null;
  const query = useQuery({
    queryKey: MONETIZE_QUERY_KEYS.status(selectedCId ?? 0),
    queryFn: () => MonetizeApi.getStatus(selectedCId!),
    enabled,
    staleTime: 60 * 1000,
  });
  return { status: query.data, isLoading: enabled && query.isLoading, isError: query.isError, error: query.error, refetch: query.refetch };
}
